/**
 * Carousel Dots
 */

import React from 'react'
import { Box } from '@mui/material'
import type { DotProps } from 'react-multi-carousel'

interface Props extends DotProps {
	items: number
}

const Dots = (Props: Props) => {
	const { carouselState, onClick, active, index } = Props

	return (
		<Box
			onClick={() => onClick?.()}
			sx={{
				width: active ? 18 : 12,
				height: 12,
				borderRadius: active ? 5 : '50%',
				backgroundColor: active ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.9)',
                marginRight: 1,
				cursor: 'pointer',
                marginBottom: 3,
                transition: 'all 0.3s ease',
			}}
		/>
	)
}

export default Dots
